export const constants = {
  trxRetry: 60, // 1 minute
  userIdle: 900, // 15 mins in seconds
};
